import Icon from "../ui/Icon";
import React from "react";

const  FAQ =()=>{
    return (
        <>
            <div className="d-flex align-items-start border-bottom pb-6 mb-5">
                <div className="me-4">
                    <Icon name="question" width="28" height="28" fill="secondary"/>
                </div>
                <div>
                    <p className="fw-bolder mb-1 fs-md lh-base">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua.
                    </p>
                    <p className="mb-0 fw-normal fs-xs">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    </p>
                </div>
            </div>
        </>
    )
}

export default FAQ;
